const ServerError = (props) => {
    return (
        <div className="m-4">
            <h3>Something went wrong on our side. Please try again later.</h3>
            {
                process.env.REACT_APP_NODE_ENV="dev" && <h3>{ props.error }</h3>
            }
        </div>
    )
}

export default ServerError;